import angular from 'angular';
import '../../services/group';
import '../../services/errors';
import '../../services/line-flow-type-organization';

const module = angular.module('whyline.modals.group', [
  'whyline.services.group',
  'whyline.services.line-flow-type-organization',
]);

const GroupModalController = (
  $state,
  $scope,
  $uibModalInstance,
  $translate,
  NotificationService,
  GroupService,
  ErrorService,
  combinedGroup,
  LineFlowTypeOrganizationService,
) => {
  'ngInject';

  $scope.placeId = $state.params.placeId;
  $scope.combinedGroup = combinedGroup;
  $scope.placeGroup = combinedGroup.group;
  $scope.callLogicList = [];

  const init = () => {
    // Initialize edit status
    restoreEditStatus();
    // Get available call logics for the current organization
    if ($scope.placeId) {
      LineFlowTypeOrganizationService.GetAllEnabledByPlace($scope.placeId, false)
        .then(lftoList => {
          $scope.callLogicList = lftoList;
          restoreEditStatus();
        })
        .catch(error => {
          ErrorService.handler(error);
        });
    }
  };

  const restoreEditStatus = () => {
    // If there's no specific configuration for the place, we show the organization config
    const automaticCall = [true, false].includes($scope.placeGroup.configuration.automaticCall.enabled)
      ? $scope.placeGroup.configuration.automaticCall.enabled
      : $scope.combinedGroup.automaticCall;
    const callLogicID = !!$scope.placeGroup.defaultLineFlowTypeOrganization
      ? $scope.placeGroup.defaultLineFlowTypeOrganization
      : $scope.combinedGroup.defaultLineFlowTypeOrganization;

    $scope.editStatus = {
      editingAutomaticCall: false,
      automaticCall,
      editingCallLogic: false,
      callLogic: $scope.callLogicList ? $scope.callLogicList.find(callLogic => callLogic._id === callLogicID) : undefined,
    };
  }

  $scope.cancelAutomaticCallEdition = () => {
    restoreEditStatus();
  };

  $scope.cancelCallLogicEdition = () => {
    restoreEditStatus();
  };

  $scope.save = () => {
    const updateGroup = {
      _id: $scope.placeGroup._id,
      data: {
        placeId: $scope.placeGroup.placeId,
        organizationGroupId: $scope.placeGroup.organizationGroupId,
        defaultLineFlowTypeOrganization: $scope.editStatus.callLogic._id,
        configuration: {
          automaticCall: {
            enabled: $scope.editStatus.automaticCall
          }
        }
      }
    };
    GroupService.Update(updateGroup)
      .then((groupUpdated) => {
        $scope.placeGroup = groupUpdated.data;
        $scope.combinedGroup.group = groupUpdated.data;
        const msgSuccess = $translate.instant('group_update_succ').replace('{name}', $scope.combinedGroup.label);
        NotificationService.Success(msgSuccess);
        restoreEditStatus();
        $uibModalInstance.close('cancel');
      })
      .catch((error) => {
        ErrorService.handler(error);
      });
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  init();
};

module.exports = module.controller('GroupModalController', GroupModalController);
